import { render, staticRenderFns } from "./WidgetListGroup.vue?vue&type=template&id=326a4110&scoped=true&"
import script from "./WidgetListGroup.vue?vue&type=script&lang=js&"
export * from "./WidgetListGroup.vue?vue&type=script&lang=js&"
import style0 from "./WidgetListGroup.vue?vue&type=style&index=0&id=326a4110&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326a4110",
  null
  
)

export default component.exports